module.exports = __webpack_public_path__ + "files/d274e7787c3d8bca12d5279efe7eeed6.svg";